import React, { useState } from 'react';
import { BreadCrumb } from '../../components/common/breadcrumb';

export const Configuration = () => {
    const breadcrumbItems = [
        { label: 'Home Page', url: '/' },
        { label: 'Configuration' },
    ];

    const [formValues, setFormValues] = useState({
        globalAdmin: '',
        businessUnitAdmin: '',
        businessUnitUser: '',
        numberOfChildNotes: '0',
    });

    const [formErrors, setFormErrors] = useState({
        globalAdmin: '',
        businessUnitAdmin: '',
        businessUnitUser: '',
    });

    const [isFormSubmitted, setIsFormSubmitted] = useState(false);

    const handleInputChange = (fieldName, value) => {

        setFormErrors({ ...formErrors, [fieldName]: '' });


        setFormValues({ ...formValues, [fieldName]: value });
    };

    const validateForm = () => {
        const errors = {};

        if (formValues.numberOfChildNotes === '0') {
            errors.numberOfChildNotes = '* Please select a value greater than 0';
        }

        if (!formValues.globalAdmin) {
            errors.globalAdmin = '* Global Admin group name is required';
        }
        if (!formValues.businessUnitAdmin) {
            errors.businessUnitAdmin = '* Business Unit Admin group name is required';
        }
        if (!formValues.businessUnitUser) {
            errors.businessUnitUser = '* Business Unit User group name is required';
        }

        setFormErrors(errors);

        if (formValues.numberOfChildNotes === '0') {
            return false;
        }

        return Object.values(errors).every((error) => error === '');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsFormSubmitted(true);

        if (validateForm()) {

        }
    };
    return (
        <>
            <div className='right-content'>
                <BreadCrumb items={breadcrumbItems}></BreadCrumb>
                <div className='mid-box-wrap config-mid'>
                    <div className='config-top'>
                        <h4 className='sub-head'>Configuration</h4>
                        <p className='config-top-text'>App Settings</p>
                    </div>
                    <div className='config-top'>
                        <span>No. of Child Notes</span>
                        <select
                            className={`form-select ${formErrors.numberOfChildNotes && 'error'}`}
                            aria-label='Default select example'
                            value={formValues.numberOfChildNotes}
                            onChange={(e) => handleInputChange('numberOfChildNotes', e.target.value)}
                        >
                            <option value='0'>0</option>
                            <option value='1'>1</option>
                            <option value='2'>2</option>
                            <option value='3'>3</option>
                        </select>
                        {isFormSubmitted && formErrors.numberOfChildNotes && (
                            <p className='error-message'>{formErrors.numberOfChildNotes}</p>
                        )}
                        <p className='config-top-text'>Azure Group Mapping</p>
                    </div>
                    <form className='add-form config-form' onSubmit={handleSubmit}>
                        <div className='row'>
                            <div className='col-md-6 add-user-label'>
                                <div class="mb-2">
                                    <label for="name" class="form-label">Global admin</label>
                                    <input
                                        type='text'
                                        className={`form-control ${formErrors.globalAdmin && 'error'}`}
                                        id='globalAdmin'
                                        placeholder='Enter global admin group name'
                                        value={formValues.globalAdmin}
                                        onChange={(e) => handleInputChange('globalAdmin', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.globalAdmin && (
                                        <p className='error-message'>{formErrors.globalAdmin}</p>
                                    )}
                                </div>
                                <div class="mb-2">
                                    <label for="admin" class="form-label">Business unit admin</label>

                                    <input
                                        type='text'
                                        className={`form-control ${formErrors.businessUnitAdmin && 'error'}`}
                                        id='admin'
                                        placeholder='Enter business unit admin group name'
                                        value={formValues.businessUnitAdmin}
                                        onChange={(e) => handleInputChange('businessUnitAdmin', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.businessUnitAdmin && (
                                        <p className='error-message'>{formErrors.businessUnitAdmin}</p>
                                    )}
                                </div>
                                <div class="mb-2">
                                    <label for="user" class="form-label">Business unit user</label>
                                    <input
                                        type='text'
                                        className={`form-control ${formErrors.businessUnitUser && 'error'}`}
                                        id='user'
                                        placeholder='Enter business unit user group name'
                                        value={formValues.businessUnitUser}
                                        onChange={(e) => handleInputChange('businessUnitUser', e.target.value)}
                                    />
                                    {isFormSubmitted && formErrors.businessUnitUser && (
                                        <p className='error-message'>{formErrors.businessUnitUser}</p>
                                    )}
                                </div>

                                <div className='add-submit'>
                                    <button className='btn btn-primary' type='submit'>Submit</button>
                                </div>
                            </div>
                        </div>

                    </form>
                </div>
            </div>
        </>
    )
}